import constants from '@/components/tools/constants'

function isMerchant (merchant) {
  if (merchant === undefined || merchant === null) {
    return false
  } else {
    return merchant?.merchantId !== null
  }
}

function customerFirstName (customer, merchant) {
  try {
    if (isMerchant(merchant)) {
      return merchant?.contactName
    } else if (customer?.commercialCustomerContactName) {
      return customer?.commercialCustomerContactName
    } else {
      return customer?.name
    }
  } catch (e) {
    console.error(e)
  }
  return undefined
}

function customerLastName (customer, merchant) {
  try {
    if (isMerchant(merchant)) {
      return merchant?.contactSurname
    } else if (customer?.commercialCustomerContactSurname) {
      return customer?.commercialCustomerContactSurname
    } else {
      return customer?.surname
    }
  } catch (e) {
    console.error(e)
  }
  return undefined
}

function customerPhone (customer, merchant) {
  try {
    if (isMerchant(merchant)) {
      return merchant?.phone
    } else if (customer?.commercialCustomerContactPhone) {
      return customer?.commercialCustomerContactPhone
    } else {
      return customer?.phone
    }
  } catch (e) {
    console.error(e)
  }
  return undefined
}

function customerStreet (customerAddress, merchantAddress, merchant) {
  try {
    if (isMerchant(merchant)) {
      return merchantAddress?.street
    } else {
      return customerAddress?.street
    }
  } catch (e) {
    console.error(e)
  }
  return undefined
}

function customerZipCode (customerAddress, merchantAddress, merchant) {
  try {
    if (isMerchant(merchant)) {
      return merchantAddress?.zipCode
    } else {
      return customerAddress?.zipCode
    }
  } catch (e) {
    console.error(e)
  }
  return undefined
}

function customerCity (customerAddress, merchantAddress, merchant) {
  try {
    if (isMerchant(merchant)) {
      return merchantAddress?.city
    } else {
      return customerAddress?.city
    }
  } catch (e) {
    console.error(e)
  }
  return undefined
}

function customerCountry (customerAddress, merchantAddress, merchant) {
  try {
    if (isMerchant(merchant)) {
      return merchantAddress?.country
    } else {
      return customerAddress?.country
    }
  } catch (e) {
    console.error(e)
  }
  return undefined
}

function getUserData (customer, merchant, customerAddress, merchantAddress) {
  const data = {}
  if (customer.email) {
    data.customerEmail = customer.email
    data.customerId = customer.customerId
  }
  if (customerPhone(customer, merchant)) {
    data.customerPhone = customerPhone(customer, merchant)
  }
  if (customerFirstName(customer, merchant)) {
    data.customerFirstName = customerFirstName(customer, merchant)
  }
  if (customerLastName(customer, merchant)) {
    data.customerLastName = customerLastName(customer, merchant)
  }
  if (customerStreet(customerAddress, merchantAddress, merchant)) {
    data.customerStreet = customerStreet(customerAddress, merchantAddress, merchant)
  }
  if (customerZipCode(customerAddress, merchantAddress, merchant)) {
    data.customerZipCode = customerZipCode(customerAddress, merchantAddress, merchant)
  }
  if (customerCity(customerAddress, merchantAddress, merchant)) {
    data.customerCity = customerCity(customerAddress, merchantAddress, merchant)
  }
  if (customerCountry(customerAddress, merchantAddress, merchant)) {
    data.customerCountry = customerCountry(customerAddress, merchantAddress, merchant)
  }

  return data
}

function getSource (source, route) {
  if (source) {
    return source
  }
  if (route.name.startsWith('index___')) {
    return constants.TP.SOURCE.MAIN_LP
  }
  if (route.name.startsWith('sell')) {
    return constants.TP.SOURCE.SELL
  }
  return constants.TP.SOURCE.OTHER_LP
}

export default {
  getUserData,
  getSource
}
